import React, { useContext } from 'react';
import "../styles/subShipping.css";
import appConst from '../Utilities/appConst.json';
import { LanguageContext } from "../context/language/LanguageContext";

const Asafta = (props) => {
    const languageContext = useContext(LanguageContext);

    const asaftaText = languageContext.getTranslation(appConst.ASAFTA_DETAILS);
    const asaftaTextArray = asaftaText.replace(/\.$/, '').trim().split('.');

    return (
        <div className='asafta page sub_shipping_selects text-start'>
            <div>
                {asaftaTextArray.map((line, index) => (<p key={index}>{line}.</p>))}
            </div>
            <div className='asafta_component_position'>
                {languageContext.getTranslation(appConst.ASAFTA_FOR_DISABLED_MAIN)}
                {languageContext.getTranslation(appConst.ASAFTA_FOR_DISABLED)}
            </div>
        </div>
    )
}
export default Asafta;
